export const ROWS_PER_PAGE = 2;
export const MATCH_TILE_MAX_WIDTH = 300;
